@let c = country();
@if (c.isoCode) {
    <div class="country-option">
        <img [src]="'assets/images/flags/' + c.isoCode.toLowerCase() + '.png'" class="country-flag" alt="Country flag" />
        <span>+{{ c.countryCode }}</span>
    </div>
}
